import Field from "../core/field.es6.js";
import VirtualUrgentCareTermsAndConditionsModalParagraph
  from "../paragraphs/virtual-urgent-care-terms-and-conditions-modal-paragraph.es6.js";

export default class VirtualUrgentCareTermsAndConditionsModalParagraphField extends Field {
  #overlayService;

  constructor({ overlayService, machineName, parentElement }) {
    super({
      machineName,
      parentElement,
    });

    this.#overlayService = overlayService;
  }

  get paragraph() {
    return new VirtualUrgentCareTermsAndConditionsModalParagraph({
      overlayService: this.#overlayService,
      parentElement: this,
    });
  }
}
